import React from "react";
import PropTypes from "prop-types";
import { FormFeedback } from "reactstrap";

export default function InvalidMessage(props) {
  const { message, isValid, className } = props;

  if (isValid !== false) {
    return null;
  }

  return <FormFeedback className={className}>{message}</FormFeedback>;
}

InvalidMessage.propTypes = {
  className: PropTypes.string,
  message: PropTypes.string,
  isValid: PropTypes.bool
};

InvalidMessage.defaultProps = {
  message: "Invalid input"
};



// WEBPACK FOOTER //
// ./src/Shared/Forms/InvalidMessage.js